export const tableStyles = `
  .table-container {
    overflow-x: auto;
    width: 100%;
  }
  .fixed-table {
    table-layout: fixed;
    width: 100%;
  }
  .col-sale-date {
    width: 110px;
    min-width: 110px;
  }
  .col-property {
    width: 25%;
    min-width: 230px;
  }
  .col-upset {
    width: 130px;
    min-width: 130px;
  }
  .col-downpayment {
    width: 180px;
    min-width: 180px;
  }
  .col-zillow {
    width: 180px;
    min-width: 180px;
  }
  .col-profit {
    width: 130px;
    min-width: 130px;
  }
`;

export const resizableStyles = `
  .react-resizable {
    position: relative;
    background-clip: padding-box;
  }
  .react-resizable-handle {
    position: absolute;
    right: -5px;
    bottom: 0;
    z-index: 1;
    width: 10px;
    height: 100%;
    cursor: col-resize;
  }
  .react-resizable-handle:hover {
    background-color: #e5e7eb;
  }
  .table-container {
    overflow-x: auto;
    min-width: 100%;
  }
`;

export const TABLE_THEME = {
  colors: {
    primary: '#96ffa8',
    primaryLight: '#f0fff3',
    primaryBorder: '#d7f5df',
    background: '#ffffff',
    headerBg: '#e6ffea'
  }
};